import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SystemNotificationType } from '../system-notification/system-notification-type.enum';

let $id = 0;

@Component({
  selector: 'wfm-banner-notification',
  templateUrl: './banner-notification.component.html',
  styleUrls: ['./banner-notification.component.scss']
})
export class BannerNotificationComponent {
  @Input() type: SystemNotificationType = SystemNotificationType.lowSeverityAlternate;

  @Input() descriptionText: string;

  @Output() close = new EventEmitter();

  id = 0;

  get icon(): string {
    if (this.type === SystemNotificationType.highSeverityPrimary) return 'ico-alert-dark-24';

    if (
      this.type === SystemNotificationType.highSeverityAlternate ||
      this.type === SystemNotificationType.highSeverityAcknowledged
    )
      return 'ico-alert-24';

    if (
      this.type === SystemNotificationType.moderateSeverityPrimary ||
      this.type === SystemNotificationType.moderateSeverityAlternate ||
      this.type === SystemNotificationType.moderateSeverityAcknowledged ||
      this.type === SystemNotificationType.lowSeverityPrimary ||
      this.type === SystemNotificationType.lowSeverityAlternate ||
      this.type === SystemNotificationType.lowSeverityAcknowledged
    )
      return 'ico-error-16';

    if (this.type === SystemNotificationType.success) return 'ico-checkmark-circle-16';

    return 'ico-info-24';
  }

  get iconColor(): string {
    if (this.type === SystemNotificationType.highSeverityAcknowledged) return '#a80925';
    if (this.type === SystemNotificationType.moderateSeverityAcknowledged) return '#b05f09';
    if (this.type === SystemNotificationType.lowSeverityAcknowledged) return '#bf9f0a';
    return 'currentColor';
  }

  constructor() {
    this.id = $id++;
  }
}
